import { Task } from '@myapp/contract'
import { useScheduleTask } from '../../../entities/task'
import { CalendarPlanningOverlay } from '../../calendar-planning-overlay'
import { DeadlineWarning } from './DeadlineWarning'

interface Props {
  show: boolean
  onClose: () => void
  onSuccess: () => void
  task: Task
  technicianId: number
}

export function WorkerTaskPlanOverlay({ show, onClose, onSuccess, task, technicianId }: Props) {
  const scheduleTask = useScheduleTask(task.id)

  const initialSelectedDate = (() => {
    if (!task.plannedStart) return null
    const d = new Date(task.plannedStart)
    if (d.getUTCHours() === 0 && d.getUTCMinutes() === 0) return null
    return task.plannedStart
  })()

  return (
    <CalendarPlanningOverlay
      show={show}
      onClose={onClose}
      technicianId={technicianId}
      initialSelectedDate={initialSelectedDate}
      initialWorkDuration={task.plannedWorkDuration || 60}
      initialTravelDuration={task.plannedTravelDuration || 30}
      initialDepartureDuration={task.plannedDepartureDuration || 30}
      filterExistingTasks={(tasks) => tasks.filter((t) => t.id !== task.id)}
      headerTitle="Im Kalender planen"
      saveButtonColor="#124093"
      draftTitle={task.title}
      hintText="Tippe auf eine Uhrzeit im Kalender, um den Termin zu setzen"
      onSave={async (payload) => {
        await scheduleTask.mutateAsync(payload)
        onSuccess()
      }}
      isPending={scheduleTask.isPending}
      bottomExtra={(state) => (
        <DeadlineWarning selectedDate={state.selectedDate} deadline={task.deadline ?? null} />
      )}
    />
  )
}
